import { joinClasses } from 'components/utils/react_helper';
import moment from 'moment';
import React, { Component, Fragment } from 'react';

import AvailableDate from './available_date';
import ListingFeatures from './listing_features';
import ListingPrice from './listing_price';

export default class ListingTile extends Component {
  constructor(props) {
    super(props);
  }

  renderCompareIcon() {
    return (
      <Fragment>
        <span className="home-tile__compare-text">Compare</span>
        <div className="home-tile__compare-icon">
          <span className={this.compareIconXClasses}></span>
          <span className={this.compareIconYClasses}></span>
        </div>
      </Fragment>
    );
  }

  get compareIconXClasses() {
    return joinClasses([
      `home-tile__compare-icon-x`,
      this.props.listingInCompare && `home-tile__compare-icon-x--active`,
    ]);
  }

  get compareIconYClasses() {
    return joinClasses([
      `home-tile__compare-icon-y`,
      this.props.listingInCompare && `home-tile__compare-icon-y--active`,
    ]);
  }

  render() {
    const { listing, propertyAvailableDate } = this.props;

    const { id, slug, locale, imageUrl, displayAddress, neighbourhood, town } = listing;

    return (
      <article className={'home-tile home-tile--property_available'} data-id={id}>
        {this.props.enableCompareFeature && (
          <button
            className={`home-tile__compare ${this.props.listingInCompare ? 'home-tile__compare--active' : ''}`}
            onClick={() => this.props.handleCompare(listing)}
          >
            {this.props.listingInCompare ? this.renderCompareIcon() : this.renderCompareIcon(false)}
          </button>
        )}
        <a
          href={`/${locale}/homes/${slug}`}
          className="home-tile__link"
          target={this.props.linkTarget || undefined}
          rel={this.props.linkTarget === '_blank' ? 'noopener noreferrer' : undefined}
        >
          <div className="home-tile__image" style={{ backgroundImage: `url(${imageUrl})` }}>
            {!moment().isSame(propertyAvailableDate, 'day') && <AvailableDate availableDate={propertyAvailableDate} />}
          </div>

          <div className="home-tile__details">
            <div className="home-tile__header">
              <h3 className="home-tile__header-title">{displayAddress}</h3>

              <p className="home-tile__header-neighborhood">{neighbourhood || town}</p>
            </div>

            <ListingFeatures listing={listing} />
            <ListingPrice listing={listing} priceFilter={this.props.selectedPriceOption} />
          </div>
        </a>
      </article>
    );
  }
}
